import { render, staticRenderFns } from "./PrintRoomBill.vue?vue&type=template&id=2d87fa14&scoped=true"
import script from "./PrintRoomBill.vue?vue&type=script&lang=js"
export * from "./PrintRoomBill.vue?vue&type=script&lang=js"
import style0 from "./PrintRoomBill.vue?vue&type=style&index=0&id=2d87fa14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87fa14",
  null
  
)

export default component.exports